export default {
    timeout: 10 * 1000,
    host: 'https://api.1be9588.com/', // 线上
    // host: 'https://uat-api.15a7132.com/', // uat
    webKey: 'luckygogointch-intech',
    endPoint: 'H5'
  }
